module.exports = __webpack_public_path__ + "img/fake_img.7173f1c4.png";